export const TAGGING_CONSTANT = {
  "196_4a2ViewAllCreditCards": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|view all cards|mpp:banner displayed",
    "lead_type": "cards|mpp",
    "event": "banner_displayed",
    "link_name": "marketing|view all cards|mpp:banner displayed",
    "test_id": "196_4 a2 View All Credit Cards - Banner Displayed"
  },
  "196_4a4ViewAllCreditCards_BannerClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|view all cards|mpp:banner clicked",
    "lead_type": "cards|mpp",
    "event": "banner_click",
    "test_id": "196_4 a4 View All Credit Cards - Banner Clicked"
  },
  "196_8dCompareCardMPP_ReviewOverlay": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|compare cards|mpp:reviews overlay",
    "tool_usage": "cards|compare",
    "lead_type": "cards|compare",
    "test_id": "196_8 d Compare Cards MPP - Reviews Overlay"
  },
  "196_11b_Cards_Refer_A_Friend_MPP": {
    "action_type": "page view",
    "app_hierarchy": "public|marketing|cards refer a friend|mpp",
    "event": "product_info",
    "test_id": "196_11 b Cards Refer A Friend - MPP"
  },
  "196_11c_Cards_Refer_A_Friend_Offer_Expired": {
    "action_type": "page view",
    "app_hierarchy": "secure|marketing|cards refer a friend|offer expired",
    "test_id": "196_11 c Cards Refer A Friend - Offer Expired"
  },
  "580_1Enable_Oops_PageNotFound_Citicards_com": {
    "action_type": "page view",
    "app_hierarchy": "public|enable|oops page not found citicards|landing",
    "test_id": "580_1 Enable - Oops Page Not Found Citicards.com"
  },
  "568_a_Lending_ECM_ATL_Awareness_Campaign_Landing": {
    "action_type": "page view",
    "app_hierarchy": "public|marketing|lending|ecm atl awareness campaign landing",
    "lead_type": "lending|landing",
    "test_id": "568 a Lending - ECM ATL Awareness Campaign Landing"
  },
  "467_a1_Citi_Flex_Loan_Landing": {
    "action_type": "page view",
    "app_hierarchy": "public|marketing|citi flex loan|landing",
    "lead_type": "citi flex loan|pdp",
    "test_id": "467 a1 Citi Flex Loan Landing"
  },
  "467_a3_Citi_Flex_Loan_Landing_Video": {
    "action_type": "page view",
    "app_hierarchy": "public|marketing|citi flex loan|landing:video",
    "page_inter": "video:<video_id>",
    "lead_type": "citi flex loan|pdp",
    "test_id": "467 a3 Citi Flex Loan - Landing - Video (Overlay)"
  },
  "466_a_Cards_Costco_Landing": {
    "action_type": "page view",
    "app_hierarchy": "public|marketing|costco anywhere|landing",
    "test_id": "466 a Cards - Costco - Landing"
  },
  "466_b_Cards_Costco_Cash_Rewards_Program_Terms": {
    "action_type": "page view",
    "app_hierarchy": "public|marketing|costco anywhere|terms",
    "test_id": "466 b Cards - Costco - Cash Rewards Program Terms"
  },
  "498_a_Cards_Dividend_Quarterly_Offer_Landing": {
    "action_type": "page view",
    "app_hierarchy": "public|marketing |dividend quarterly offer|landing",
    "pid": "004",
    "form_type": "Q22022",
    "test_id": "498 a Cards - Dividend Quarterly Offer - Landing"
  },
  "189aCardHomepageLoad": {
    "action_type": "page view",
    "app_hierarchy": "public|marketing|home|cards",
    "lead_type": "cards|home",
    "test_id": "189 a Cards Homepage",
    "test_version": "",
  },
  "189bCardHomepageBanner": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|home|cards",
    "lead_type": "cards|home",
    "event": "banner_displayed",
    "test_id": "189 b Cards Homepage"
  },
  "196_4jCompareNowButtonClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|compare cards|start",
    "lead_type": "cards|compare",
    "tool_usage": "cards|compare",
    "event": "product_info|card_compare_start",
    "link_name": "marketing|compare cards|start",
    "test_id": "196_4 j Compare Now Button Clicked"
  },
  "196_8eCompareCardMPP_ReviewOverlay_Sort": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|compare cards|mpp:reviews overlay:sort reviews by selected",
    "tool_usage": "cards|compare",
    "lead_type": "cards|compare",
    "event": "page_interaction",
    "link_name": "marketing|compare cards|mpp:reviews overlay:sort reviews by selected",
    "test_id": "196_8 e Compare Cards MPP - Reviews Overlay - Sort Reviews By Selected"
  },
  "467_a4_Citi_Flex_Loan_Landing_FAQ_Show_More": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|citi flex loan|landing:faq show more",
    "page_inter": "faq:<faq_title>",
    "lead_type": "citi flex loan|pdp",
    "event": "page_interaction",
    "test_id": "467 a4 Citi Flex Loan - Landing - FAQ Show More"
  },
  "467_a5_Citi_Flex_Loan_Landing_Expand_All_Sections": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|citi flex loan|landing:expand all sections",
    "lead_type": "citi flex loan|pdp",
    "event": "page_interaction",
    "test_id": "467 a5 Citi Flex Loan - Landing - Expand All Sections"
  },
  "466_c_Cards_Costco_Consumer_Card_Benefits_Guide": {
    "download_name": "CostcoCon.pdf",
    "action_type": "event",
    "app_hierarchy": "public|marketing|costco anywhere|landing:consumer card benefits guide",
    "event": "download",
    "link_name": "marketing|costco anywhere|landing:consumer card benefits guide",
    "test_id": "466 c Cards - Costco - Consumer Card Benefits Guide"
  },
  "466_d_Cards_Costco_Business_Card_Benefits_Guide": {
    "download_name": "CostcoBus.pdf",
    "action_type": "event",
    "app_hierarchy": "public|marketing|costco anywhere|landing:business card benefits guide",
    "event": "download",
    "link_name": "marketing|costco anywhere|landing:business card benefits guide",
    "test_id": "466 d Cards - Costco - Business Card Benefits Guide"
  },
  "498_a2_Cards_Dividend_Quarterly_Offer_Landing_CTA_Clicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing |dividend quarterly offer|landing:sign up for this quarter's offers",
    "pid": "004",
    "form_type": "Q22022",
    "event": "custom_link_click",
    "link_name": "<cta_link_name>",
    "test_id": "498 a2 Cards - Dividend Quarterly Offer - Landing - CTA Clicked"
  },
  "498_a3_Cards_Dividend_Quarterly_Offer_Landing_Exit_Link": {
    "action_type": "event",
    "app_hierarchy": "public|marketing |dividend quarterly offer|landing:exit link",
    "pid": "004",
    "form_type": "Q22022",
    "event": "exit_links",
    "link_name": "<third party URL>",
    "test_id": "498 a3 Cards - Dividend Quarterly Offer - Landing - Exit Link"
  },
  "196_4aViewAllCreditCards": {
    "action_type": "page view",
    "event": "product_info|product_view",
    "app_hierarchy": "public|marketing|view all cards|mpp",
    "lead_type": "cards|mpp",
    "test_id": "196_4 a View All Credit Cards",
    "test_version": ""

  },
  "212_07bCardsPre_ScreenedOffers": {
    "action_type": "page view",
    "app_hierarchy": "public|cards|pre-screened|offers",
    "lead_type":"cards|pre-screened",
    "test_id": "212_07 b Cards Pre-Screened - Offers"
  },
  "212_07b1CardsPre_ScreenedOffers_CTAClicked": {
   "action_type": "event",
    "event": "click_to_apply",
    "app_hierarchy": "public|cards|pre-screened|offers:cta clicked",
    "link_name":"Apply Now",
    "lead_type":"cards|pre-screened",
    "test_id": "212_07 b1 Cards Pre-Screened - Offers - CTA Clicked"
  },
  "212_07b4CardsPre_ScreenedOffers_AdditionalInfo": {
    "action_type": "page view",
    "app_hierarchy": "public|cards|pre-screened|offers:additional information t&cs",
    "lead_type":"cards|pre-screened",
    "test_id": "212_07 b4 Cards Pre-Screened - Offers - Additional Information T&Cs"
  },
  "212_07b5CardsPre_ScreenedOffers_PricingInfo": {
    "action_type": "page view",
    "app_hierarchy": "public|cards|pre-screened|offers:pricing and information",
    "lead_type":"cards|pre-screened",
    "test_id": "212_07 b5 Cards Pre-Screened - Offers - Pricing and Information"
  },
  "212_07b0CardsPre_ScreenedOffers_NewTabSelected": {
    "action_type": "event",
    "app_hierarchy": "public|cards|pre-screened|offers:new featured categories tab selected",
    "event": "page_interaction|product_view",
    "lead_type":"cards|pre-screened",
    "test_id": "212_07 b0 Cards Pre-Screened - Offers - Pricing and Information - New Tab Selected"
  },
  "212_07b2CardsPre_ScreenedOffers_JoinCostco": {
    "action_type": "event",
    "app_hierarchy": "public|cards|pre-screened|offers:join costco",
    "event": "exit_links",
    "lead_type":"cards|pre-screened",
    "link_name": "Join Costco",
    "test_id": "212_07 b2 Cards Pre-Screened - Offers - Join Costo"
  },
  "196_4bRewardsCreditCards": {
    "action_type": "page view",
    "event": "product_info|product_view",
    "app_hierarchy": "public|marketing|rewards|mpp",
    "lead_type": "cards|mpp",
    "test_id": "196_4 b Rewards Credit Cards"
  },
  "196_4cTravelCreditCards": {
    "action_type": "page view",
    "event": "product_info|product_view",
    "app_hierarchy": "public|marketing|travel|mpp",
    "lead_type": "cards|mpp",
    "test_id": "196_4 c Travel Credit Cards"
  },
  "196_4dBalanceTransferCreditCards": {
    "action_type": "page view",
    "event": "product_info|product_view",
    "app_hierarchy": "public|marketing|balance transfer|mpp",
    "lead_type": "cards|mpp",
    "test_id": "196_4 d Balance Transfer Credit Cards"
  },
  "196_4eIntroAPRCreditCards": {
    "action_type": "page view",
    "event": "product_info|product_view",
    "app_hierarchy": "public|marketing|zero percent intro apr|mpp",
    "lead_type": "cards|mpp",
    "test_id": "196_4 e 0% Intro APR Credit Cards"
  },
  "196_4fCashBackCreditCards": {
    "action_type": "page view",
    "event": "product_info|product_view",
    "app_hierarchy": "public|marketing|cash back|mpp",
    "lead_type": "cards|mpp",
    "test_id": "196_4 f Cash Back Credit Cards"
  },
  "196_4gBusinessCreditCards": {
    "action_type": "page view",
    "event": "product_info|product_view",
    "app_hierarchy": "public|marketing|business|mpp",
    "lead_type": "cards|mpp",
    "test_id": "196_4 g Business Credit Cards"
  },
  "196_4hNoAnnualFeeCreditCards": {
    "action_type": "page view",
    "event": "product_info|product_view",
    "app_hierarchy": "public|marketing|no annual fee|mpp",
    "lead_type": "cards|mpp",
    "test_id": "196_4 h No Annual Fee Credit Cards"
  },
  "196_4iNoForeignTransactionFeeCreditCards": {
    "action_type": "page view",
    "event": "product_info|product_view",
    "app_hierarchy": "public|marketing|no foreign transaction fee|mpp",
    "lead_type": "cards|mpp",
    "test_id": "196_4 i No Foreign Transaction Fee Credit Cards"
  },
  "196_4mAAdvantageCreditCards": {
    "action_type": "page view",
    "event": "product_info|product_view",
    "app_hierarchy": "public|marketing|aadvantage|mpp",
    "lead_type": "cards|mpp",
    "test_id": "196_4 m AAdvantage Credit Cards"
  },
  "196_4nThankYouRewardsCreditCards": {
    "action_type": "page view",
    "event": "product_info|product_view",
    "app_hierarchy": "public|marketing|thankyou rewards|mpp",
    "lead_type": "cards|mpp",
    "test_id": "196_4 n ThankYou Rewards Credit Cards"
  },
  "196_4oMastercardCreditCards": {
    "action_type": "page view",
    "event": "product_info|product_view",
    "app_hierarchy": "public|marketing|mastercard|mpp",
    "lead_type": "cards|mpp",
    "test_id": "196_4 o Mastercard Credit Cards"
  },
  "196_4pMostPopularCreditCards": {
    "action_type": "page view",
    "event": "product_info|product_view",
    "app_hierarchy": "public|marketing|most popular|mpp",
    "lead_type": "cards|mpp",
    "test_id": "196_4 p Most Popular Credit Cards"
  },
  "196_4a5ViewAllCreditCards_ApplyNowClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|view all cards|mpp:apply now",
    "lead_type": "cards|mpp",
    "event": "click_to_apply",
    "test_id": "196_4 a5 View All Credit Cards - Apply Now"
  },
  "196_4b2RewardsCreditCards_ApplyNowClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|rewards|mpp:apply now",
    "lead_type": "cards|mpp",
    "event": "click_to_apply",
    "test_id": "196_4 b2 Rewards Credit Cards - Apply Now"
  },
  "196_4c2TravelCreditCards_ApplyNowClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|travel|mpp:apply now",
    "lead_type": "cards|mpp",
    "event": "click_to_apply",
    "test_id": "196_4 c2 Travel Credit Cards - Apply Now"
  },
  "196_4d2BalanceTransferCreditCards_ApplyNowClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|balance transfer|mpp:apply now",
    "lead_type": "cards|mpp",
    "event": "click_to_apply",
    "test_id": "196_4 d2 Balance Transfer Credit Cards - Apply Now"
  },
  "196_4e20PercentIntroAPRCreditCards_ApplyNowClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|zero percent intro apr|mpp:apply now",
    "lead_type": "cards|mpp",
    "event": "click_to_apply",
    "test_id": "196_4 e2 0% Intro APR Credit Cards - Apply Now"
  },
  "196_4f2CashBackCreditCards_ApplyNowClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|cash back|mpp:apply now",
    "lead_type": "cards|mpp",
    "event": "click_to_apply",
    "test_id": "196_4 f2 Cash Back Credit Cards - Apply Now"
  },
  "196_4g2BusinessCreditCards_ApplyNowClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|business|mpp:apply now",
    "lead_type": "cards|mpp",
    "event": "click_to_apply",
    "test_id": "196_4 g2 Business Credit Cards - Apply Now"
  },
  "196_4h2NoAnnualFeeCreditCards_ApplyNowClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|no annual fee|mpp:apply now",
    "lead_type": "cards|mpp",
    "event": "click_to_apply",
    "test_id": "196_4 h2 No Annual Fee Credit Cards - Apply Now"
  },
  "196_4i2NoForeignFeeCreditCards_ApplyNowClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|no foreign transaction fee|mpp:apply now",
    "lead_type": "cards|mpp",
    "event": "click_to_apply",
    "test_id": "196_4 i2 No Foreign Transaction Fee Credit Cards - Apply Now"
  },
  "196_4m2AAdvantageCreditCards_ApplyNowClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|aadvantage|mpp:apply now",
    "lead_type": "cards|mpp",
    "event": "click_to_apply",
    "test_id": "196_4 m2 AAdvantage Credit Cards - Apply Now"
  },
  "196_4n2ThankYouRewardsCreditCards_ApplyNowClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|thankyou rewards|mpp:apply now",
    "lead_type": "cards|mpp",
    "event": "click_to_apply",
    "test_id": "196_4 n2 ThankYou Rewards Credit Cards - Apply Now"
  },
  "196_4o2MastercardCreditCards_ApplyNowClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|mastercard|mpp:apply now",
    "lead_type": "cards|mpp",
    "event": "click_to_apply",
    "test_id": "196_4 o2 Mastercard Credit Cards - Apply Now"
  },
  "196_4p2MostPopularCreditCards_ApplyNowClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|most popular|mpp:apply now",
    "lead_type": "cards|mpp",
    "event": "click_to_apply",
    "test_id": "196_4 p2 Most Popular Credit Cards - Apply Now"
  },
  "196_4a6ViewAllCreditCards_InternalLinkClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|view all cards|mpp:internal link clicked",
    "lead_type": "cards|mpp",
    "event": "custom_link_click",
    "test_id": "196_4 a6 View All Credit Cards - Internal Link Clicked"
  },
  "196_4b3RewardsCreditCards_InternalLinkClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|rewards|mpp:internal link clicked",
    "lead_type": "cards|mpp",
    "event": "custom_link_click",
    "test_id": "196_4 b3 Rewards Credit Cards - Internal Link Clicked"
  },
  "196_4c3TravelCreditCards_InternalLinkClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|travel|mpp:internal link clicked",
    "lead_type": "cards|mpp",
    "event": "custom_link_click",
    "test_id": "196_4 c3 Travel Credit Cards - Internal Link Clicked"
  },
  "196_4d3BalanceTransferCreditCards_InternalLinkClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|balance transfer|mpp:internal link clicked",
    "lead_type": "cards|mpp",
    "event": "custom_link_click",
    "test_id": "196_4 d3 Balance Transfer Credit Cards - Internal Link Clicked"
  },
  "196_4e30PercentIntroAPRCreditCards_InternalLinkClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|zero percent intro apr|mpp:internal link clicked",
    "lead_type": "cards|mpp",
    "event": "custom_link_click",
    "test_id": "196_4 e3 0% Intro APR Credit Cards - Internal Link Clicked"
  },
  "196_4f3CashBackCreditCards_InternalLinkClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|cash back|mpp:internal link clicked",
    "lead_type": "cards|mpp",
    "event": "custom_link_click",
    "test_id": "196_4 f3 Cash Back Credit Cards - Internal Link Clicked"
  },
  "196_4g3BusinessCreditCards_InternalLinkClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|business|mpp:internal link clicked",
    "lead_type": "cards|mpp",
    "event": "custom_link_click",
    "test_id": "196_4 g3 Business Credit Cards - Internal Link Clicked"
  },
  "196_4h3NoAnnualFeeCreditCards_InternalLinkClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|no annual fee|mpp:internal link clicked",
    "lead_type": "cards|mpp",
    "event": "custom_link_click",
    "test_id": "196_4 h3 No Annual Fee Credit Cards - Internal Link Clicked"
  },
  "196_4i3NoForeignFeeCreditCards_InternalLinkClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|no foreign transaction fee|mpp:internal link clicked",
    "lead_type": "cards|mpp",
    "event": "custom_link_click",
    "test_id": "196_4 i3 No Foreign Transaction Fee Credit Cards - Internal Link Clicked"
  },
  "196_4m3AAdvantageCreditCards_InternalLinkClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|aadvantage|mpp:internal link clicked",
    "lead_type": "cards|mpp",
    "event": "custom_link_click",
    "test_id": "196_4 m3 AAdvantage Credit Cards - Internal Link Clicked"
  },
  "196_4n3ThankYouRewardsCreditCards_InternalLinkClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|thankyou rewards|mpp:internal link clicked",
    "lead_type": "cards|mpp",
    "event": "custom_link_click",
    "test_id": "196_4 n3 ThankYou Rewards Credit Cards - Internal Link Clicked"
  },
  "196_4o3MastercardCreditCards_InternalLinkClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|mastercard|mpp:internal link clicked",
    "lead_type": "cards|mpp",
    "event": "custom_link_click",
    "test_id": "196_4 o3 Mastercard Credit Cards - Internal Link Clicked"
  },
  "196_4p3MostPopularCreditCards_InternalLinkClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|most popular|mpp:internal link clicked",
    "lead_type": "cards|mpp",
    "event": "custom_link_click",
    "test_id": "196_4 p3 Most Popular Credit Cards - Internal Link Clicked"
  },
  "196_4a7ViewAllCreditCards_Reviews": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|view all cards|mpp:reviews",
    "lead_type": "cards|mpp",
    "test_id": "196_4 a7 View All Credit Cards - Reviews"
  },
  "196_4b4RewardsCreditCards_Reviews": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|rewards|mpp:reviews",
    "lead_type": "cards|mpp",
    "test_id": "196_4 b4 Rewards Credit Cards - Reviews"
  },
  "196_4c4TravelCreditCards_Reviews": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|travel|mpp:reviews",
    "lead_type": "cards|mpp",
    "test_id": "196_4 c4 Travel Credit Cards - Reviews"
  },
  "196_4d4BalanceTransferCreditCards_Reviews": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|balance transfer|mpp:reviews",
    "lead_type": "cards|mpp",
    "test_id": "196_4 d4 Balance Transfer Credit Cards - Reviews"
  },
  "196_4e40PercentIntroAPRCreditCards_Reviews": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|zero percent intro apr|mpp:reviews",
    "lead_type": "cards|mpp",
    "test_id": "196_4 e4 0% Intro APR Credit Cards - Reviews"
  },
  "196_4f4CashBackCreditCards_Reviews": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|cash back|mpp:reviews",
    "lead_type": "cards|mpp",
    "test_id": "196_4 f4 Cash Back Credit Cards - Reviews"
  },
  "196_4g4BusinessCreditCards_Reviews": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|business|mpp:reviews",
    "lead_type": "cards|mpp",
    "test_id": "196_4 g4 Business Credit Cards - Reviews"
  },
  "196_4h4NoAnnualFeeCreditCards_Reviews": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|no annual fee|mpp:reviews",
    "lead_type": "cards|mpp",
    "test_id": "196_4 h4 No Annual Fee Credit Cards - Reviews"
  },
  "196_4i4NoForeignFeeCreditCards_Reviews": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|no foreign transaction fee|mpp:reviews",
    "lead_type": "cards|mpp",
    "test_id": "196_4 i4 No Foreign Transaction Fee Credit Cards - Reviews"
  },
  "196_4m4AAdvantageCreditCards_Reviews": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|aadvantage|mpp:reviews",
    "lead_type": "cards|mpp",
    "test_id": "196_4 m4 AAdvantage Credit Cards - Reviews"
  },
  "196_4n4ThankYouRewardsCreditCards_Reviews": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|thankyou rewards|mpp:reviews",
    "lead_type": "cards|mpp",
    "test_id": "196_4 n4 ThankYou Rewards Credit Cards - Reviews"
  },
  "196_4o4MastercardCreditCards_Reviews": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|mastercard|mpp:reviews",
    "lead_type": "cards|mpp",
    "test_id": "196_4 o4 Mastercard Credit Cards - Reviews"
  },
  "196_4p4MostPopularCreditCards_Reviews": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|most popular|mpp:reviews",
    "lead_type": "cards|mpp",
    "test_id": "196_4 p4 Most Popular Credit Cards - Reviews"
  },
  "196_4a8ViewAllCreditCards_AdditionalInformation": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|view all cards|mpp:additional information",
    "lead_type": "cards|mpp",
    "test_id": "196_4 a8 View All Credit Cards - Additional Information"
  },
  "196_4b5RewardsCreditCards_AdditionalInformation": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|rewards|mpp:additional information",
    "lead_type": "cards|mpp",
    "test_id": "196_4 b5 Rewards Credit Cards - Additional Information"
  },
  "196_4c5TravelCreditCards_AdditionalInformation": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|travel|mpp:additional information",
    "lead_type": "cards|mpp",
    "test_id": "196_4 c5 Travel Credit Cards - Additional Information"
  },
  "196_4d5BalanceTransferCreditCards_AdditionalInformation": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|balance transfer|mpp:additional information",
    "lead_type": "cards|mpp",
    "test_id": "196_4 d5 Balance Transfer Credit Cards - Additional Information"
  },
  "196_4e50PercentIntroAPRCreditCards_AdditionalInformation": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|zero percent intro apr|mpp:additional information",
    "lead_type": "cards|mpp",
    "test_id": "196_4 e5 0 Percent Intro APR Credit Cards - Additional Information"
  },
  "196_4f5CashBackCreditCards_AdditionalInformation": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|cash back|mpp:additional information",
    "lead_type": "cards|mpp",
    "test_id": "196_4 f5 Cash Back Credit Cards - Additional Information"
  },
  "196_4g5BusinessCreditCards_AdditionalInformation": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|business|mpp:additional information",
    "lead_type": "cards|mpp",
    "test_id": "196_4 g5 Business Credit Cards - Additional Information"
  },
  "196_4h5NoAnnualFeeCreditCards_AdditionalInformation": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|no annual fee|mpp:additional information",
    "lead_type": "cards|mpp",
    "test_id": "196_4 h5 No Annual Fee Credit Cards - Additional Information"
  },
  "196_4i5NoForeignFeeCreditCards_AdditionalInformation": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|no foreign transaction fee|mpp:additional information",
    "lead_type": "cards|mpp",
    "test_id": "196_4 i5 No Foreign Transaction Fee Credit Cards - Additional Information"
  },
  "196_4m5AAdvantageCreditCards_AdditionalInformation": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|aadvantage|mpp:additional information",
    "lead_type": "cards|mpp",
    "test_id": "196_4 m5 AAdvantage Credit Cards - Additional Information"
  },
  "196_4n5ThankYouRewardsCreditCards_AdditionalInformation": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|thankyou rewards|mpp:additional information",
    "lead_type": "cards|mpp",
    "test_id": "196_4 n5 ThankYou Rewards Credit Cards - Additional Information"
  },
  "196_4o5MastercardCreditCards_AdditionalInformation": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|mastercard|mpp:additional information",
    "lead_type": "cards|mpp",
    "test_id": "196_4 o5 Mastercard Credit Cards - Additional Information"
  },
  "196_4p5MostPopularCreditCards_AdditionalInformation": {
    "action_type": "page view",
    "page_type": "overlay",
    "app_hierarchy": "public|marketing|most popular|mpp:additional information",
    "lead_type": "cards|mpp",
    "test_id": "196_4 p5 Most Popular Credit Cards - Additional Information"
  },

  // "196_8aCompareCardMPP": {
  //   "action_type": "page view",
  //   "tool_usage": "cards|compare",
  //   "lead_type": "cards|compare",
  //   "test_id": "196_8 a Compare Cards MPP",
  //   "app_hierarchy": "public|marketing|Compare credit cards"
  // },
  "465_1aCards_GooglePay_Landing": {
    "action_type": "page view",
    "app_hierarchy": "public|marketing|google pay|landing",
    "test_id": "465_1 a Cards - Google Pay - Landing",
    "evarpagename": "us|web|public|marketing|google pay|landing"
  },
  "499_1aCards_SamsungPay_Landing": {
    "action_type": "page view",
    "app_hierarchy": "public|marketing|samsung pay|landing",
    "test_id": "499_1 a Cards - Samsung Pay - Landing",
    "evarpagename": "us|web|public|marketing|samsung pay|landing"
  },
  "499_1a2_Cards_SamsungPay_HowToPay": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|samsung pay|how to pay with samsung pay",
    "evarpagename": "us|web|public|marketing|samsung pay|how to pay with samsung pay",
    "event": "page_interaction",
    "page_inter": "How to pay with Samsung Pay",
    "test_id": "499_1 a2 Cards - Samsung Pay - How to pay with Samsung Pay"
  },
  "499_1a3_Cards_SamsungPay_HowToaddyourCitiCards": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|samsung pay|how to add your citi cards to samsung pay",
    "evarpagename": "us|web|public|marketing|samsung pay|how to add your citi cards to samsung pay",
    "event": "page_interaction",
    "page_inter": "How to add your Citi Cards to Samsung Pay",
    "test_id": "499_1 a3 Cards - Samsung Pay - How to add your Citi Cards to Samsung Pay"
  },
  "499_1a4_Cards_SamsungPay_WheretopaywithSamsungPay": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|samsung pay|where to pay with samsung pay",
    "evarpagename": "us|web|public|marketing|samsung pay|where to pay with samsung pay",
    "event": "page_interaction",
    "page_inter": "Where to pay with Samsung Pay",
    "test_id": "499_1 a4 Cards - Samsung Pay - Where to pay with Samsung Pay"
  },
  "465_1a2Cards_GooglePayHowtoPay": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|google pay|how to pay with google pay",
    "evarpagename": "us|web|public|marketing|google pay|how to pay with google pay",
    "event": "page_interaction",
    "page_inter": "How to pay with Google Pay",
    "test_id": "465_1 a2 Cards - Google Pay - How to pay with Google Pay"
  },
  "465_1a3_Cards_GooglePay_HowToAddYourCitiCards": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|google pay|how to add your citi cards to google pay",
    "evarpagename": "us|web|public|marketing|google pay|hot to add your citi cards to google pay",
    "event": "page_interaction",
    "page_inter": "How to add your Citi Cards to Google Pay",
    "test_id": "465_1 a3 Cards - Google Pay - How to add your Citi Cards to Google Pay"
  },
  "465_1a4_Cards_GooglePayWhereToPay": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|google pay|where to pay with google pay",
    "evarpagename": "us|web|public|marketing|google pay|where to pay with google pay",
    "event": "page_interaction",
    "page_inter": "Where to pay with Google Pay",
    "test_id": "465_1 a4 Cards - Google Pay - Where to pay with Google Pay"
  },
  '641_a_citishop_landing': {
    "action_type": 'page view',
    "app_hierarchy": "public|marketing|citi shop|landing",
    "lead_type": "cards|citi shop",
    "test_id": "641 a Citi Shop - Landing",
  },
  '641_a2_citishop_landing_ctaclicked': {
    "action_type": 'event',
    "app_hierarchy": "public|marketing|citi shop|landing:cta clicked",
    "event": "custom_link_click",
    "lead_type": "cards|citi shop",
    "test_id": "641 a2 Citi Shop - Landing - CTA Clicked"
  },
  '641_a3_citishop_landing_expandall': {
    "action_type": 'event',
    "app_hierarchy": "public|marketing|citi shop|landing:expand all",
    "event": "page_interaction",
    "lead_type": "cards|citi shop",
    "page_inter": "Expand All",
    "test_id": "641 a3 Citi Shop - Landing - Expand All"
  },
  '641_a4_citishop_landing_seeallfaqs': {
    "action_type": 'event',
    "app_hierarchy": "public|marketing|citi shop|landing:see all faqs",
    "event": "page_interaction",
    "lead_type": "cards|citi shop",
    "page_inter": "See all FAQs",
    "test_id": "641 a4 Citi Shop - Landing - See all FAQs"
  },
  '641_a5_citishop_landing_showfaq': {
    "action_type": 'event',
    "app_hierarchy": "public|marketing|citi shop|landing:show faq",
    "event": "page_interaction",
    "lead_type": "cards|citi shop",
    "test_id": "641 a5 Citi Shop - Landing - Show FAQ"
  },
  '641_a6_citishop_landing_article_CTAClicked': {
    "action_type": 'event',
    "app_hierarchy": "public|marketing|citi shop|landing:article cta clicked",
    "event": "custom_link_click",
    "lead_type": "cards|citi shop",
    "test_id": "641 a6 Citi Shop - Landing - Article CTA Clicked"
  },
  '196_12_a_Cards_AAdvantageMicrosite_Compare_Card': {
    "action_type": "page view",
    "app_hierarchy": "public|marketing|AAdvantage Microsite|compare cards",
    "lead_type": "cards|mpp",
    "event": "product_view",
    "test_id": "196_12 a Cards - AAdvantage Microsite - Compare Cards"
  },
  "196_12_b_Cards_AAdvantageMicrosite_Compare_Card": {
    "action_type": "page view",
    "app_hierarchy": "public|marketing|AAdvantage Microsite|[product_name]",
    "lead_type": "cards|pdp",
    "event": "product_view",
    "product_name": "AAdvantage MileUp Mastercard Travel Credit Card",
    "test_id": "196_12 b Cards - AAdvantage Microsite - PDP"
  },
  "196_8bCompareCardMPP_RemoveCard": {
    "tool_usage": "cards|compare",
    "action_type": "event",
    "app_hierarchy": "public|marketing|compare cards|mpp:remove a card",
    "lead_type": "cards|compare",
    "link_name": "marketing|compare cards|mpp:remove a card",
    "test_id": "196_8 b Compare Cards MPP - Remove a Card"
  },
  "196_8cCompareCardMPP_Undo": {
    "tool_usage": "cards|compare",
    "action_type": "event",
    "app_hierarchy": "public|marketing|compare cards|mpp:undo",
    "lead_type": "cards|compare",
    "event": "page_interaction|product_view",
    "link_name": "marketing|compare cards|mpp:undo",
    "test_id": "196_8 c Compare Cards MPP - Undo"
  },
  "196_4_l6_cards_pdp_call_to_apply": {
    "action_type": "page view",
    "page_type": "overlay",
    "form_type": "Internally Hosted",
    "lead_type": "cards|pdp",
    "test_id": "196_4 l6 Cards Product Details Page - Call to Apply Modal"
  },
    "196_4k_CompareCardsPage": {
    "action_type": "page view",
    "event": "product_view|card_compare_complete",
    "tool_usage": "cards|compare",
    "lead_type": "cards|compare",
    "test_id": "196_4 k Compare Cards Page",
    "app_hierarchy": "public|marketing|compare cards|complete"
  },
    "196_4_k2_Compare_Cards_ApplyNow":{
    "action_type": "event",
    "app_hierarchy": "public|marketing|compare cards|complete:apply now",
    "event": "click_to_apply",
    "lead_type": "cards|mpp",
    "test_id": "196_4 k2 Compare Cards - Apply Now"
  },
   "196_4_k3_Compare_Cards_InternalLinkClicked":{
    "action_type": "event",
    "app_hierarchy": "public|marketing|compare cards|complete:internal link clicked",
    "event": "custom_link_click",
    "lead_type": "cards|mpp",
    "test_id": "196_4 k3 Compare Cards - Internal Link Clicked"
  },
    "196_4_k4_Compare_Cards_Reviews":{
    "action_type": "page_view",
    "app_hierarchy": "public|marketing|compare cards|complete:reviews",
    "page_type": "overlay",
    "lead_type": "cards|mpp",
    "test_id": "196_4 k4 Compare Cards - Reviews"
  },
  "196_4_k5_Compare_Cards_AdditionalInformation":{
    "action_type": "page_view",
    "app_hierarchy": "public|marketing|compare cards|complete:additional information",
    "page_type":"overlay",
    "lead_type": "cards|mpp",
    "test_id": "196_4 k5 Compare Cards - Additional Information"
  },
  "196_4qRetailStoreCreditCards": {
    "action_type": "page_view",
    "app_hierarchy": "public|marketing|retail store credit cards|mpp",
    "event": "product_info|product_view",
    "lead_type": "cards|mpp",
    "pid": "The Home Depot Consumer Credit Card,Shop Your Way Mastercard,My Best Buy Credit Cards,Shell Fuel Rewards Mastercard,Shell Fuel Rewards Card,Macy's Credit Cards",
    "test_id": "196_4 q Retail Store Credit Cards"
  },
  "196_4q2RetailStoreCreditCards_ApplyNowClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|retail store credit cards|mpp:apply now",
    "lead_type": "cards|mpp",
    "event": "click_to_apply",
    "test_id": "196_4 q2 Retail Store Credit Cards - Apply Now"
  },
  "196_4q3RetailStoreCreditCards_InternalLinkClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|retail store credit cards|mpp:internal link clicked",
    "lead_type": "cards|mpp",
    "event": "custom_link_click",
    "test_id": "196_4 q3 Retail Store Credit Cards - Internal Link Clicked"
  },
  "641_b_CitiShop_PreLogin_Instructions_ioschrome": {
    "action_type": "page view",
    "app_hierarchy": "public|marketing|citi shop|pre-login instructions - ioschrome",
    "lead_type": "cards|citi shop pre-login instructions",
    "test_id": "641 b Citi Shop - Pre-Login Instructions - ioschrome"
  },
  "641_b2_CitiShop_PreLogin_Instructions_ioschrome_CTAClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|citi shop|pre-login instructions - ioschrome:cta clicked",
    "event": "page_interaction|exit_links",
    "lead_type": "cards|citi shop pre-login instructions",
    "page_inter": "here",
    "test_id": "641 b2 Citi Shop - Pre-Login Instructions - ioschrome - CTA Clicked"
  },
  "641_c_CitiShop_PreLogin_Instructions_iossafari": {
    "action_type": "page view",
    "app_hierarchy": "public|marketing|citi shop|pre-login instructions - iossafari",
    "lead_type": "cards|citi shop pre-login instructions",
    "test_id": "641 c Citi Shop - Pre-Login Instructions - iossafari"
  },
  "641_d_CitiShop_PreLogin_Instructions_iosedge": {
    "action_type": "page view",
    "app_hierarchy": "public|marketing|citi shop|pre-login instructions - iosedge",
    "lead_type": "cards|citi shop pre-login instructions",
    "test_id": "641 d Citi Shop - Pre-Login Instructions - iosedge"
  },
  "641_e_CitiShop_PreLogin_Instructions_androidchrome": {
    "action_type": "page view",
    "app_hierarchy": "public|marketing|citi shop|pre-login instructions - androidchrome",
    "lead_type": "cards|citi shop pre-login instructions",
    "test_id": "641 e Citi Shop - Pre-Login Instructions - androidchrome"
  },
  "641_e2_CitiShop_PreLogin_Instructions_androidchrome_CTAClicked": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|citi shop|pre-login instructions - androidchrome:cta clicked",
    "event": "page_interaction|exit_links",
    "lead_type": "cards|citi shop pre-login instructions",
    "page_inter": "here",
    "test_id": "641 e2 Citi Shop - Pre-Login Instructions - androidchrome - CTA Clicked"
  },
  "641_f_CitiShop_PreLogin_Instructions_androidedge": {
    "action_type": "page view",
    "app_hierarchy": "public|marketing|citi shop|pre-login instructions - androidedge",
    "lead_type": "cards|citi shop pre-login instructions",
    "test_id": "641 f Citi Shop - Pre-Login Instructions - androidedge"
  },
  "641_c4_citishop_prelogin_instructions_videoInteraction": {
      "action_type": "page view",
      "app_hierarchy": "public|marketing|citi shop|pre-login instructions - iossafari: video interaction",
      "event": "page_interaction",
      "lead_type": "cards|citi shop pre-login instructions",
      "page_inter": "<part_id>",
      "test_id": "641 c4 Citi Shop - Pre-Login Instructions - iossafari - Video Interaction"
  },
  "641_c5_citishop_prelogin_instructions_CTAClicked": {
      "action_type": "page view",
      "app_hierarchy": "public|marketing|citi shop|pre-login instructions - iossafari: cta clicked",
      "event": "custom_link_click",
      "link_name": "<cta_title>",
      "lead_type": "cards|citi shop pre-login instructions",
      "test_id": "641 c4 Citi Shop - Pre-Login Instructions - iossafari - CTA Clicked"
  },
  "196_4_l_Cards_PDP": {
    "action_type": "event",
    "app_hierarchy": "public|marketing|<card_product_name>|pdp:exit link clicked",
    "lead_type": "cards|pdp",
    "event": "exit_links",
    "test_id": "196_4 l19 Cards Product Details Page - Exit Link Clicked",
    "form_type": "<Internally Hosted or Internally Hosted|<aa_page_version>>",
    "link_name":"<exit_link_section>|<exit_link_title>"
   },
   "196_4_l_Cards_PDP_NewTabSelected": {
    "test_id": "196_4 l18 Cards Product Details Page - New Tab Selected",
    "action_type": "event",
    "event": "page_interaction",
    "lead_type": "cards|pdp",
    "form_type": "<Internally Hosted or Internally Hosted|<aa_page_version>>",
    "page_inter": "<tab_number>|<tab_name>",
    }

}
